import { singleton } from '@front-app/util/interface';
import { getGroupStatsStore } from '../modules/groupStats';

export const GroupStatsStore = singleton(getGroupStatsStore);
